<template>
  <div class="home" id="home" :style="cssVars">
    <!-- banner isPcSize -->
    <div class="banner" :class="'b'+global.year.slice(0, 4)">
      <!-- <img src="../assets/img/banner_new.jpg" class="bg-img"> -->
      <img src="../assets/img/banner_2026_1_2-.jpg" class="bg-img" v-if="global.area_id == 4886" width="1260" height="746">
      <div class="detail">
        <h1>MPD AI驱动创新峰会<p>Make Professional Discovery</p></h1>
        <h2>打造高效技术管理团队<br>驱动企业增长与技术革新</h2>
        <div class="info">
          <!-- <p class="wrap-flex-start">
            <span class="glyphicon glyphicon-time"></span>
            <span class="trueData">{{time}}</span>
            <span class="glyphicon glyphicon-map-marker"></span>
            <span class="truePlace">{{(address!=''&&address!='未定') ? address : global.config[global.area_id]['title']}}{{(global.config[global.area_id].trueplace&&global.config[global.area_id].trueplace!='')?('-'+global.config[global.area_id].trueplace):''}}</span>
          </p> -->
          <!-- <div class="wrap-flex-start"> -->
          <div class="wrap-flex-end">
            <button v-if="global.config[global.area_id]['invitation']">
              <a :href="global.config[global.area_id]['invitation']" target="_blank" download="MPD邀请函">下载大会邀请函</a>
              <!-- <a :href="global.config[global.area_id]['invitation']" target="_blank">大会邀请函</a> -->
            </button>
            <button v-if="global.config[global.area_id]['collect_producer']">
              <a :href="global.config[global.area_id]['collect_producer']" target="_blank">查看出品人邀请函</a>
            </button>
            <button v-if="global.config[global.area_id]['collect_case']">
              <a :href="global.config[global.area_id]['collect_case']" target="_blank">查看议题邀请函</a>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="pc_content jieshao bgcolor-main">
      <div class="con">
        <h1 class="h1">打造高效技术管理团队、驱动企业增长与技术革新</h1>
        <p>MPD会议重磅升级，聚焦大模型时代研发角色全线升级！本会议深度拆解AI驱动下的产品创新和工程实践，看顶尖团队的真实实践，实现10倍效能提升，加速产品创新。现场揭秘落地案例，避开大坑，掌握可复制打法，一起「卷」出下一代研发范式！</p>
      </div>
    </div>
    <!-- 精选案例 -->
    <div class="pc_content anli">
      <div class="con">
        <h1 class="h1 pc">精选案例<img class="refresh" src="../assets/img/refresh.png" alt=""
        @click="refreshCases" v-if="caseList.length>caseRenderLength['pc']"></h1>
        <h1 class="h1 mob">精选案例<img class="refresh" src="../assets/img/refresh.png" alt=""
        @click="refreshCases" v-if="caseList.length>caseRenderLength['mob']"></h1>
        <Cases :datalist="caseRender"></Cases>
        <div class="morebtn">
          <router-link :to="formatHref('/case')">查看全部案例</router-link>
        </div>
        <div class="morebtn_blank"></div>
      </div>
    </div>
    <!-- 联席主席 / 出品人 -->
    <div class="pc_content person bgcolor-con">
      <div class="con" v-if="global.config[global.area_id]['chairman']">
        <h1 class="h1 pc">联席主席</h1>
        <h1 class="h1 mob">联席主席</h1>
        <Lecturers :datalist="chairmen" :type="'chairman'"></Lecturers>
      </div>
      <div class="con" v-if="global.area_id!=='4288'">
        <h1 class="h1 pc">出品人</h1>
        <h1 class="h1 mob">出品人</h1>
        <Lecturers :datalist="lecturers" :type="'producer'"></Lecturers>
        <div class="morebtn">
          <router-link :to="formatHref('/experts')">查看更多嘉宾</router-link>
        </div>
        <div class="morebtn_blank"></div>
      </div>
      <div class="con" v-else>
        <h1 class="h1 pc">演讲嘉宾</h1>
        <h1 class="h1 mob">演讲嘉宾</h1>
        <Lecturers :datalist="guests" :type="'teacher'"></Lecturers>
        <div class="morebtn">
          <router-link :to="formatHref('/experts')">查看更多嘉宾</router-link>
        </div>
        <div class="morebtn_blank"></div>
      </div>
    </div>
    <!-- 为什么 -->
    <!-- <div class="pc_content why">
      <div class="con pc">
        <h1 class="h1 pc">为什么来MPD</h1>
        <div class="pc">
          <img v-if="global.area_id=='4288'" src="../assets/img/bgimages/why_imgf_40.png">
          <img v-else-if="global.year>'2023'" src="../assets/img/bgimages/why_imgf_66.png">
          <img v-else-if="['2023','2020'].includes(global.year.toString())" src="../assets/img/bgimages/why_imgf_84.png">
          <img v-else src="../assets/img/bgimages/why_imgf_98.png">
        </div>
      </div>
      <div class="con mob">
        <h1 class="h1 mob">为什么来MPD</h1>
        <div class="mob">
          <img v-if="global.area_id=='4288'" src="../assets/img/bgimages/why_img_40.png">
          <img v-else-if="global.year>'2023'" src="../assets/img/bgimages/why_img_66.png" alt="">
          <img v-else-if="['2023','2020'].includes(global.year.toString())" src="../assets/img/bgimages/why_img_84.png" alt="">
          <img v-else src="../assets/img/bgimages/why_img_98.png" alt="">
        </div>
      </div>
    </div> -->
    <!-- 收获 -->
    <div class="pc_content shouhuo bgcolor-main">
      <div class="con pc">
        <h1 class="h1 pc">参会学员收获</h1>
        <div class="shouhuoz pc">
          <img src="../assets/img/yinhao_01.png">
          <div class="wenzi">
            <div class="slogan">
              <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                  <li
                    v-for="(item,index) in shouhuo" :key="'shouhuo_li_'+ index"
                    data-target="#carousel-example-generic"
                    :data-slide-to="index"
                    :class="index==0?'active':''"
                  ></li>
                </ol>
                <div class="carousel-inner" role="listbox" style="height: 170px;">
                  <div class="item" :class="index==parseInt(shouhuo.length/2)?'active':''" v-for="(item,index) in shouhuo" :key="'shouhuo_'+index">
                    <p v-html="item.word"></p>
                    <h6 v-html="'——'+item.person"></h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img src="../assets/img/yinhao_02.png">
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="con mob">
        <h1 class="h1 mob">参会学员收获</h1>
        <div class="shouhuoz mob">
          <img src="../assets/img/wap_yinhao_01.png">
          <div class="wenzi">
            <div class="slogan">
              <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                  <li data-target="#carousel-example-generic" data-slide-to="0" class=""></li>
                  <li data-target="#carousel-example-generic" data-slide-to="1" class="active"></li>
                  <li data-target="#carousel-example-generic" data-slide-to="2" class=""></li>
                </ol>
                <div class="carousel-inner" role="listbox" style="height: 170px;">
                  <div class="item" :class="index==parseInt(shouhuo.length/2)?'active':''" v-for="(item,index) in shouhuo" :key="'shouhuo_'+index">
                    <p v-html="item.word"></p>
                    <h6 v-html="'——'+item.person"></h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img src="../assets/img/wap_yinhao_02.png">
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- 如果 -->
    <div class="pc_content ruguo">
      <div class="con pc">
        <h1 class="h1 pc">如果你是</h1>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 text-center">
            <div class="img">
              <img src="../assets/img/rug_01.png">
              <p>面对着时代瞬变和市场未知的炮火，急于带领团队转型突围和提升研发效率的<b>研发管理者</b></p>
            </div>
          </div>
          <div class="kb2"></div>
          <div class="col-lg-4 col-md-4 col-sm-4 text-center">
            <div class="img">
              <img src="../assets/img/rug_02.png">
              <p>渴望指数型增长，期望利用先进体验设计和创新思维带领产品跨越式发展的<b>创新带头人</b></p>
            </div>
          </div>
          <div class="kb2"></div>
          <div class="col-lg-4 col-md-4 col-sm-4 text-center">
            <div class="img">
              <img src="../assets/img/rug_03.png">
              <p>焦虑于纷至沓来的技术新趋势和敢于利用新技术带领团队跨越技术鸿沟的<b>技术架构师</b></p>
            </div>
          </div>
        </div>
        <h2>我们欢迎你的加入!</h2>
      </div>
      <div class="con mob">
        <h1 class="h1 mob">如果你是</h1>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <div class="img">
              <img src="../assets/img/rug_01.png">
              <p>面对着时代瞬变和市场未知的炮火，急于带领团队转型突围和提升研发效率的<b>研发管理者</b></p>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <div class="img">
              <img src="../assets/img/rug_02.png">
              <p>渴望指数型增长，期望利用先进体验设计和创新思维带领产品跨越式发展的<b>创新带头人</b></p>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <div class="img">
              <img src="../assets/img/rug_03.png">
              <p>焦虑于纷至沓来的技术新趋势和敢于利用新技术带领团队跨越技术鸿沟的<b>技术架构师</b></p>
            </div>
          </div>
        </div>
        <h2>我们欢迎你的加入!</h2>
      </div>
    </div>
    <!-- 回顾 -->
    <div class="pc_content huigu bgcolor-main">
      <div class="con">
        <h1 class="h1 pc">往期回顾</h1>
        <h1 class="h1 mob">往期回顾</h1>
        <time-line :sid="global.area_id" :timeList="timeList"></time-line>
      </div>
    </div>
    <!-- 赞助 -->
    <div class="pc_content history_com">
      <div class="con" v-if="!(typeof sponsers === 'object' && Object.keys(sponsers).length > 0)">
        <h1 class="h1">媒体社区支持</h1>
      </div>
      <div class="con" v-for="(sponser,key) in sponsers" :key="'sponser_'+key">
        <h1 class="h1 pc">{{key}}</h1>
        <h1 class="h1 mob">{{key}}</h1>
        <ul :style="formatcom[key] ? 'justify-content:center;' : ''">
          <li v-for="(item,index) in sponser" :key="'sponser_'+key+'_'+index" :class="formatcom[key]?'':'long'">
            <div>
              <a :href="item.content.indexOf('://')!=-1?item.content:'http://'+item.content" target="_blank">
                <img :src="item.file" width="100%">
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="con">
        <div class="morebtn">
          <router-link :to="formatHref('/sponsor')">更多媒体</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinScreen, mixinSession } from '../mixin'

export default {
  name: 'Home',
  components: {
    Cases: () => import('../componentsNew/Cases.vue'),
    Lecturers: () => import('../componentsNew/Lecturers.vue'),
    TimeLine: () => import('../components/TimeLine.vue')
  },
  mixins: [ mixinScreen, mixinSession ],
  data () {
    return {
      time: '',
      address: '',
      cases: [],
      caseList: [],
      caseRender: [],
      caseRenderLength: { pc: 9, mob: 6 },
      caseRandom: { pc: [], mob: [] },
      refreshTime: 0.35,
      renderHistory: [],
      courses: [],
      chairmen: [],
      lecturers: [],
      guests: [],
      sponsers: {},
      formatcom: {},
      shouhuo: [
        {word: '每次参加MPD都是一次快速提升的经历，通过学习别人的经验可以让我们自己的开发少走弯路。', person: 'Jessica<br>花旗银行项目经理'},
        {word: '今年的MPD引入了视觉引导系统，在听完课后，把视觉引导图拍走，回家可以根据引导图迅速回忆起老师讲的东西', person: 'Lion<br>中兴通信系统架构师'},
        {word: '参加MPD最大的好处就是能让团队的成员串场听工作范围以外的一些分享和案例，这对培养全面素质的技术管理者很有好处', person: 'Dina<br>Hp测试经理'},
        {word: '每年派人参加MPD就是因为可以在这里动手实践一些东西，我觉得这比单纯的技术分享对别人的启发大', person: 'Dacid<br>一号店产品负责人'}
      ],
      timeList: {sec: 0, list: []}
    }
  },
  computed: {
    cssVars () {
      return {
        '--refresh-time': this.refreshTime + 's'
      }
    }
  },
  watch: {
    cases: {
      handler (_new, _old) {
        // console.log('cases', _new, _old)
        if (
          _new === null ||
          (_new && _new.length && (!this.courses || this.courses.length === 0))
        ) {
          this.getCourses()
        }
      },
      deep: true,
      immediate: true
    },
    courses: {
      handler (_new, _old) {
        // console.log('courses', _new, _old)
        let list = []
        if (this.cases && this.cases.length) {
          for (let item of this.cases) {
            list.push({
              courseid: item.content,
              title: item.content_note,
              teacher: []
            })
          }
        }
        if (_new && _new.length > 0 && (!_old || _old.length === 0)) {
          if (list && list.length) {
            for (let item of list) {
              for (let course of _new) {
                if (
                  (item.courseid && item.courseid.toString()) ===
                  (course.courseid && course.courseid.toString())
                ) {
                  item.teacher = course.teacher
                  break
                }
              }
            }
          } else {
            for (let course of _new) {
              list.push({
                courseid: course.courseid,
                title: course.title,
                teacher: course.teacher
              })
            }
          }
        }
        this.caseList = this.global.safeDeepClone(list)
      },
      deep: true,
      immediate: true
    },
    caseList: {
      handler (_new, _old) {
        // console.log('case_list', _new, _old)
        if (_new && _new.length) {
          let screenWidth = window.innerWidth
          let limit = screenWidth > 767 ? this.caseRenderLength['pc'] : this.caseRenderLength['mob']
          if (_new.length > limit) {
            this.$nextTick(() => {
              this.getRandom(_new)
            })
          } else {
            this.caseRender = this.global.safeDeepClone(_new)
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    localStorage.removeItem('case_random_pc')
    localStorage.removeItem('case_random_mob')
    this.$nextTick(() => {
      this.getPlace()
      this.getReview()
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.getCases()
      if (this.global.area_id === '4288') {
        this.getGuest()
      } else {
        this.getChairmen()
        this.getLecturers()
      }
      if (this.global.area_id >= '4288') {
        this.getSponsersType()
      } else {
        this.getSponsers()
      }
    })
  },
  methods: {
    getPlace: function () {
      let purl = this.global.urlNew.place + this.global.area_id
      this.$http
        .jsonp(purl)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log(res)
          if (res.status === 200 || res.status === '200') {
            this.time = this.global.formatTime(res.data.startTime, 'Y.M.D') + '-' + this.global.formatTime(res.data.endTime, 'D')
            this.address = this.global.area_id.toString() === '2699' ? '线上' : (
              (res.data.address && res.data.address !== '未定')
                ? res.data.address
                : (this.global.area_id === '4288' ? '北京' : '上海海神诺富特大酒店')
            ) // 2021->2022上海站2699改为线上
          }
        })
    },
    getCases: function () {
      // sue推荐位仅id和title，通过id匹配all获得teacher
      let cid = this.global.id_list['case']
      if (cid && cid !== '') {
        let curl = this.global.urlNew.sue['all'] + cid
        this.$http.jsonp(curl)
          .then((res) => {
            return res.json()
          })
          .then((res) => {
            // console.log('cases ', res)
            if ((res.errno === 0 || res.errno === '0') && res.data && res.data[0] && res.data[0].length) {
              this.cases = res.data[0]
            } else {
              this.getRecommend()
            }
          })
      } else {
        this.getRecommend()
      }
    },
    getRecommend: function () {
      let rid = this.global.id_list['recommend']
      if (rid && rid !== '') {
        let rurl = this.global.urlNew.sue['all'] + rid
        this.$http.jsonp(rurl)
          .then((res) => {
            return res.json()
          })
          .then((res) => {
            // console.log('cases ', res)
            if ((res.errno === 0 || res.errno === '0') && res.data && res.data[0] && res.data[0].length) {
              this.cases = res.data[0]
            } else {
              this.cases = null
            }
          })
      } else {
        this.cases = null
      }
    },
    getCourses: function () {
      let url = this.global.urlNew.course['all'] + this.global.area_id
      this.$http.jsonp(url)
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          // console.log('courses ', data)
          if ((data.errno === 0 || data.errno === '0') && data.data && data.data.length) {
            this.courses = data.data
          }
        })
    },
    getChairmen: function () {
      let cid = this.global.id_list['chairman']
      if (cid) {
        let curl = this.global.urlNew.sue['lecturer'] + cid
        this.$http.jsonp(curl)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            // console.log(data)
            if (data.errno === 0 || data.errno === '0') {
              this.chairmen = data.data[cid] || []
            }
          })
      }
    },
    getLecturers: function () {
      // 大会 2699 -
      // 实际日程共计28会场，27专题，27位出品人
      // 接口获取共计28会场，26专题，27位出品人
      // 第一日上/下午两场智能金融专题实为两位出品人故为两个专题，但在专题接口被整合为同一专题，使出品人‘杨青’无对应专题
      let lid = this.global.id_list['lecturer']
      if (lid && lid !== '') {
        let lurl = this.global.urlNew.sue['lecturer'] + lid
        let surl = this.global.urlNew.subject + this.global.area_id
        this.$http.jsonp(surl)
          .then((res) => {
            return res.json()
          })
          .then((res) => {
            console.log('getLecturers ', lid, res, surl)
            this.$http.jsonp(lurl)
              .then((data) => {
                return data.json()
              })
              .then((data) => {
                if (data.errno === 0 || data.errno === '0') {
                  // console.log('home getLecturers ', res.data, data.data[lid])
                  this.lecturers = data.data[lid]
                  if ((res.errno === 0 || res.errno === '0') && res.data && res.data.length) {
                    for (var i = 0; i < this.lecturers.length; i++) {
                      for (let j = 0; j < res.data.length; j++) {
                        // console.log(this.lecturers[i].id, res.data[j].producerId, this.lecturers[i].id == res.data[j].producerId)
                        if ((this.lecturers[i].id === res.data[j].producerId) || (this.lecturers[i].id && this.lecturers[i].id.toString()) === (res.data[j].producerId && res.data[j].producerId.toString())) {
                          // console.log(this.lecturers[i].name, res.data[j].venueName)
                          this.lecturers[i].subjectId = res.data[j].id
                          this.lecturers[i].subjectName = res.data[j].venueName
                          break
                        }
                      }
                    }
                  }
                }
              })
          })
      }
    },
    getGuest: function () {
      let gurl = this.global.urlNew.speaker + this.global.area_id
      this.$http.jsonp(gurl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log('experts guests ',data)
          if (data.errno === 0 || data.errno === '0') {
            this.guests = data.data
          }
        })
    },
    getSponsersType: function () {
      let sid = this.global.id_list['sponser']
      if (sid && sid !== '') {
        let surl = this.global.urlNew.sue['type'] + sid
        this.$http.jsonp(surl)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            if ((res.errno === 0 || res.errno === '0') && res.data && res.data.length) {
              this.global.id_list['sponsertype'] = []
              for (let i = 0; i < res.data.length; i++) {
                this.global.id_list['sponsertype'].push(res.data[i].typeName)
              }
              this.getSponsers()
            }
          })
      }
    },
    getSponsers: function () {
      let sid = this.global.id_list['sponser']
      if (sid && sid !== '') {
        let surl = this.global.urlNew.sue['all'] + sid
        this.$http.jsonp(surl)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            if (data.errno === 0 || data.errno === '0') {
              console.log('sponsers ', data)
              let typeNameList = []
              let list = data.data[0]
              typeNameList = this.global.id_list['sponsertype']
              let newList = {}
              for (let i = 0; i < typeNameList.length; i++) {
                newList[typeNameList[i]] = []
                list.map((item) => {
                  if (item.typeName === typeNameList[i]) {
                    newList[typeNameList[i]].push(item)
                  }
                })
              }
              this.sponsers = newList
              // console.log(this.sponsers)
              Object.keys(this.sponsers).forEach((key) => {
                let item = this.sponsers[key]
                this.formatcom[key] = item.length >= 5
              })
              if (this.global.id_list['history']) {
                this.getSponsersHistory()
              }
            }
          })
      }
    },
    getSponsersHistory: function () {
      let sid = this.global.id_list['history']
      let surl = this.global.urlNew.sue['all'] + sid
      this.$http.jsonp(surl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if (data.errno === 0 || data.errno === '0') {
            // console.log('sponsers-history ',data)
            if (data.data && data.data[0] && data.data[0].length) {
              data.data[0].map((item) => {
                this.sponsers['历史参会企业'].push(item)
              })
            }
          }
        })
    },
    getReview: function () {
      var urlReview = this.global.url.review
      this.$http
        .jsonp(urlReview)
        .then((data) => {
          return data.json()
        })
        .then((obj) => {
          // console.log('Home getReview ',obj);
          if (obj.errno && obj.errno.toString() === '0') {
            // getReview
            let review = []
            let reviewYearKeys = Object.keys(obj.data)
            let maxYear = 0
            for (let i = 0; i < reviewYearKeys.length; i++) {
              maxYear = Math.max(maxYear, parseInt(reviewYearKeys[i]))
            }
            let thisTime = new Date().getTime()
            let reviewFlag = []
            let flag = 0
            reviewYearKeys.map(year => {
              obj.data[year].map(item => {
                if ((item.startTime * 1000 + 2 * 24 * 60 * 60 * 1000) > thisTime) {
                  flag++
                  reviewFlag.push(item)
                }
              })
            })
            reviewFlag.sort(this.global.toSortKey('startTime', 1, 'string'))
            // console.log(review_flag);
            review = flag > 0 ? reviewFlag : []
            // console.log("Home this.review：",review);
            this.review = review
            /* homeTimeLine */
            let timeKeys = Object.keys(obj.data)
            let len = 0
            for (let i = 0; i < timeKeys.length; i++) {
              len += obj.data[timeKeys[i]].length
            }
            this.timeList.sec = len
            // console.log('line ',timeKeys,len);
            if (timeKeys.length >= 4) {
              for (let i = 0; i < 4; i++) {
                if (i < 3) {
                  this.timeList.list.push({year: '', list: []})
                  this.timeList.list[i].year = timeKeys[timeKeys.length - 1 - i]
                  len = len - obj.data[this.timeList.list[i].year].length
                  this.timeList.list[i].len = len
                  this.timeList.list[i].list = obj.data[this.timeList.list[i].year].reverse()
                } else {
                  this.timeList.list.push({year: ''})
                  this.timeList.list[i].year = timeKeys[timeKeys.length - 1 - i]
                  len = len - obj.data[this.timeList.list[i].year].length
                  this.timeList.list[i].len = len
                }
              }
            } else {
              for (let i = 0; i < timeKeys.length; i++) {
                this.timeList.list.push({year: '', list: []})
                this.timeList.list[i].year = timeKeys[timeKeys.length - 1 - i]
                len = len - obj.data[this.timeList.list[i].year].length
                this.timeList.list[i].len = len
                this.timeList.list[i].list = obj.data[this.timeList.list[i].year].reverse()
                for (let lindex in this.timeList.list[i].list) {
                  const laid = this.timeList.list[i].list[lindex].id
                  this.timeList.list[i].list[lindex].jieshu = (this.global.config[laid] && this.global.config[laid].jieshu) || ''
                  this.timeList.list[i].list[lindex].title = (this.global.config[laid] && this.global.config[laid].title) || ''
                }
              }
            }
            // console.log('timeList ',this.timeList);
          }
        })
    },
    //
    refreshCases: function (e) {
      // eslint-disable-next-line no-undef
      $(e.target).addClass('rotate')
      let screenWidth = window.innerWidth
      let randomArrNow = screenWidth > 767 ? this.caseRandom['pc'] : this.caseRandom['mob']
      let renderLength = screenWidth > 767 ? this.caseRenderLength['pc'] : this.caseRenderLength['mob']
      // console.log(screenWidth, this.caseList, this.renderHistory)
      this.caseRender = []
      if (this.renderHistory.length === this.caseList.length) {
        this.renderHistory = []
        console.log('------ ', randomArrNow)
        for (let i of randomArrNow) {
          this.renderHistory.push(i)
          this.caseRender.push(this.caseList[i])
        }
      } else {
        for (let i = 0; i < renderLength; i++) {
          // console.log(i, this.renderHistory)
          for (let c in this.caseList) {
            if (!this.renderHistory.includes(parseInt(c))) {
              this.renderHistory.push(parseInt(c))
              this.caseRender.push(this.caseList[c])
              break
            }
          }
        }
      }
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        $(e.target).removeClass('rotate')
      }, this.refreshTime * 1000)
    },
    getRandom: function (list) {
      let cases = list ? this.global.safeDeepClone(list) : this.global.safeDeepClone(this.caseList)
      let _randomPC = localStorage.getItem('case_random_pc')
      let _randomMob = localStorage.getItem('case_random_mob')
      let _randomArrPC = (_randomPC && _randomPC.split(',')) || []
      let _randomArrMob = (_randomMob && _randomMob.split(',')) || []
      let _randomArr = { pc: _randomArrPC, mob: _randomArrMob }
      let _name = { pc: 'case_random_pc', mob: 'case_random_mob' }
      this.renderHistory = []
      this.caseRender = []
      let num = 0 // 随机数、渲染长度、上一次渲染索引列表、当前渲染索引列表
      let renderLength = 0
      let randomArrPre = []
      let randomArrNow = []
      for (let type of ['pc', 'mob']) {
        renderLength = this.caseRenderLength[type]
        randomArrNow = this.caseRandom[type]
        randomArrPre = _randomArr[type]
        for (let i = 0; i < renderLength; i++) {
          num = this.global.setRandom(0, cases.length - 1)
          if (!num || randomArrNow.includes(num) || randomArrPre.includes(num)) {
            i--
          } else {
            randomArrNow.push(num)
          }
        }
        this.caseRandom[type] = randomArrNow
        localStorage.setItem(_name[type], randomArrNow)
      }
      let screenWidth = window.innerWidth
      randomArrNow = screenWidth > 767 ? this.caseRandom['pc'] : this.caseRandom['mob']
      for (let index of randomArrNow) {
        this.renderHistory.push(index)
        this.caseRender.push(cases[index])
      }
      window.addEventListener('resize', () => {
        screenWidth = window.innerWidth
        randomArrNow = screenWidth > 767 ? this.caseRandom['pc'] : this.caseRandom['mob']
        this.renderHistory = []
        this.caseRender = []
        for (let index of randomArrNow) {
          this.renderHistory.push(index)
          this.caseRender.push(cases[index])
        }
      })
    }
    //
  }
}
</script>

<style lang="scss">
#app {
  .year_after .home {
    .pc_content {
      &.why, &.huigu {
        position: relative;
        z-index: 3;
        &::before {
          content: '';
          display: block;
          width: 100%;
          height: 100%;
          max-width: 1598px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          background-color: var(--main-bgcolor);
        }
        .con {
          position: relative;
          z-index: 3;
        }
      }
      &.why {
        // .con.pc {
        //   background-image: url(../assets/img/bgimages/why_01_bg.png);
        // }
        .con.mob {
          background-image: none;
          background-color: #ffffff;
        }
      }
      @media (max-width: 767px) {
        &.jieshao .con {
          h1 {
            padding-top: 15px;
            padding-bottom: 10px;
          }
          p {
            line-height: 20px;
            padding-bottom: 20px;
          }
        }
      }
    }
  }

  .home {
    .banner {
      height: auto;
      min-height: auto;
      position: relative;
      background-color: #ffffff;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100%;
      overflow-x: hidden;
      box-shadow: 0 0 3px 1px #f5f5f5;
      * {
        position: relative;
        z-index: 3;
      }
      .bg-img {
        width: 100vw;
        height: auto;
        max-width: 1600px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
      }
      .detail {
        width: 100%;
        height: 100%;
        // max-width: 1440px;
        max-width: 1200px;
        position: absolute;
        top: 0;
        left: 50%;
        z-index: 2;
        transform: translateX(-50%);
        background-color: transparent;
        --size-base: 1vw; // max(100vw)=1600px ~ 1vw=16px
        --size-h1: calc(var(--size-base) * 4.5);
        --size-h1-p: calc(var(--size-base) * 1.5 - 1px);
        --size-h2: calc(var(--size-base) * 2 + 2px);
        --size-p: calc(var(--size-base) * 1.5 + 1px);
        --size-button: calc(var(--size-base) + 2px);
        --size-button-h: calc(var(--size-base) * 1.5);
        h1 {
          width: 100%;
          // line-height: 80px;
          // font-size: 72px;
          line-height: calc(var(--size-h1) / 9 * 10);
          font-size: var(--size-h1);
          font-weight: 600;
          color: #000;
          text-align: left;
          margin-top: 75px;
          p {
            line-height: 1;
            font-size: var(--size-h1-p);
            color: #666;
            text-align: left;
            letter-spacing: 2px;
          }
        }
        h2 {
          width: 100%;
          line-height: calc(var(--size-h2) + 6px);
          font-size: var(--size-h2);
          font-weight: 400;
          color: #666;
          text-align: left;
          margin-top: 30px;
          // color: var(--main-color);
          // opacity: .6;
          // display: none;
        }
        .info {
          width: 100%;
          height: auto;
          display: grid;
          align-content: flex-end;
          align-items: flex-end;
          position: absolute;
          bottom: 30%;
          // bottom: 36%;
          text-align: left;
          p, span {
            line-height: 1;
            font-size: var(--size-p);
            font-weight: 400;
            color: #000;
            text-align: left;
            &.glyphicon {
              margin-right: 8px;
              margin-top: -2px;
            }
            & + .glyphicon {
              margin-left: 15px;
            }
          }
          div[class*="wrap-flex"] {
            flex-wrap: wrap;
          }
          button {
            width: fit-content;
            height: fit-content;
            min-width: calc(var(--size-button) * 10);
            min-height: calc(var(--size-button-h) * 2.5);
            margin-top: var(--size-button);
            background: #ececec;
            border: none;
            border-radius: 4px;
            margin-left: 20px;
            margin-right: 20px;
            // &:not(:nth-last-of-type(1)) {
            // }
            a {
              display: inline-block;
              width: 100%;
              height: 100%;
              line-height: calc(var(--size-button-h) * 2);
              text-align: center;
              &:hover {
                color: var(--main-color);
                text-decoration: var(--main-color) underline;
              }
            }
            * {
              font-size: var(--size-button);
              // line-height: var(--size-button-h);
              color: #6c6f70;
            }
          }
        }
      }
      &.b2026 {
        text-align: center;
        /*
        &::before, &::after {
          content: '';
          position: absolute;
          top: 0;
          z-index: 0;
          width: 50%;
          height: 100%;
        }
        &::before {
          left: 0;
          background: linear-gradient(to bottom, #1111D5 0%, #0006B4 20%, #00014B 80%, #191854 100%);
        }
        &::after {
          right: 0;
          background-color: rgba(0, 0, 0, 0.5);
          background: linear-gradient(to bottom, #0C1461 0%, #030E62 10%, #045493 36%, #09C9DC 70%, #08E5F4 85%, #0AF1F6 100%);
        }
        */
        .bg-img {
          max-width: 1260px;
        }
        .detail {
          padding-left: 0;
          --size-p: calc(var(--size-base) * 2);
          --size-button: calc(var(--size-base) + 6px);
          --size-button-h: calc(var(--size-base) * 1.5);
          h1, h2 {
            display: none;
          }
          .info {
            p, span {
              color: #fff;
            }
            // [class*="wrap-flex"] {
            //   justify-content: center;
            // }
            button {
              margin-top: calc(var(--size-button) * 1.5);
            }
          }
        }
      }
      @media (min-width: 1600px) {
        .detail {
          --size-base: 16px;
          --size-h1: 72px;
          --size-h1-p: 23px;
          --size-h2: 34px;
          --size-p: 25px;
        }
      }
      @media (max-width: 1400px) {
        overflow: hidden;
        text-align: right;
        .detail {
          h1 {
            margin-top: 30px;
          }
          h2 {
            margin-top: 30px;
          }
          .info {
            // bottom: 30px;
          }
        }
      }
      @media (max-width: 1230px) {
        .detail {
          padding-left: 15px;
          h1 {
            margin-top: 30px;
          }
        }
      }
      @media (max-width: 960px) {
        .detail {
          h1 {
            margin-top: 25px;
          }
          h2 {
            margin-top: 25px;
          }
          .info button {
            margin-top: 5px;
          }
        }
      }
      @media (max-width: 767px) {
        .bg-img {
          height: 180px;
          object-fit: cover;
          object-position: right top;
        }
        .detail {
          --size-base: 6px;
          --size-h1: 24px;
          --size-h1-p: 10px;
          --size-h2: 13px;
          --size-p: 12px;
          --size-button: 12px;
          --size-button-h: 10px;
          h1 {
            margin-top: 20px;
            line-height: 25px;
          }
          h2 {
            margin-top: 12px;
            line-height: 18px;
          }
          .info {
            bottom: 5px;
            p, span {
              line-height: 1;
            }
            [class*="wrap-flex"] {
              flex-direction: column;
              align-items: flex-start;
              justify-content: flex-start;
            }
            button {
              min-width: calc(var(--size-button) * 9);
              margin-right: 30vw;
              // &:not(:nth-last-of-type(1)) {
              //   margin-right: 10px;
              // }
            }
          }
        }
        &.b2026 {
          text-align: center;
          .bg-img {
            width: 100vw;
            height: auto;
            // max-width: 360px;
            margin: 0 auto;
            object-position: center top;
          }
          .detail {
            .info {
              button {
                // margin-top: var(--size-button);
                margin-top: calc(var(--size-button) / 2);
              }
            }
          }
        }
      }
    }
    .pc_content {
      .con {
        h1.h1.mob {
          padding-top: 30px;
          padding-bottom: 25px;
        }
      }
      &.jieshao {
        .con {
          max-width: 1050px;
          padding: 0;
          h1.h1 {
            padding-top: 23px;
            padding-bottom: 15px;
            text-align: center;
            color: #ffffff;
            font-size: 25px;
            line-height: 1.25;
            letter-spacing: 2px;
            // letter-spacing: 0px;
          }
          p {
            color: #ffffff;
            text-align: left;
            font-weight: normal;
            font-size: 16.5px;
            line-height: 25px;
            text-align: justify;
            margin-top: 0;
            margin-bottom: 0;
            padding-bottom: 20px;
          }
        }
      }
      &.anli {
        .con {
          h1.pc {
            padding-top: 50px;
            padding-bottom: 40px;
          }
          .h1 {
            position: relative;
            .refresh {
              width: 25px;
              height: 25px;
              object-fit: cover;
              position: absolute;
              left: 50%;
              top: 50%;
              margin-left: 95px;
              margin-top: -8px;
              cursor: url("../assets/img/images/mouse3.png"), auto;
              &.rotate {
                animation: rotate var(--refresh-time) linear;
              }
            }
            @keyframes rotate {
              from {
                transform: rotate(0deg)
              }
              to {
                transform: rotate(180deg)
              }
            }
          }
        }
      }
      &.person {
        .con {
          h1 {
            padding-top: 70px;
            padding-bottom: 70px;
          }
          .nolist {
            width: 100%;
            text-align: center;
            font-size: 18px;
            color: var(--deep-color);
          }
        }
      }
      &.why {
        padding: 0;
        .con {
          &.pc {
            max-width: 1600px;
            margin-bottom: 90px;
            background-repeat: no-repeat;
            background-position: center;
            h1 {
              padding-top: 80px;
              padding-bottom: 40px;
            }
            div.pc {
              max-width: 992px;
              height: 290px;
              margin: 0 auto;
              margin-top: 42px;
              img {
                width: 100%;
                margin-top: 32px;
              }
            }
          }
          &.mob {
            margin-bottom: 20px;
            div.mob {
              width: 100%;
              img {
                width: 100%;
              }
            }
          }
        }
      }
      &.shouhuo {
        .con {
          h1 {
            padding-top: 60px;
            padding-bottom: 30px;
          }
          .shouhuoz {
            img {
              width: 13%;
              float: left;
            }
            img:nth-of-type(2) {
              float: right;
            }
            .wenzi {
              float: left;
              width: 71.4%;
              margin: 0 auto;
              margin-top: 30px;
              .slogan {
                width: 85%;
                margin: 0 auto;
                p {
                  font-size: 20px;
                  line-height: 30px;
                  color: #ffffff;
                }
                h6 {
                  margin-top: 15px;
                  float: right;
                  font-size: 17px;
                  line-height: 36px;
                  color: #ffffff;
                  text-align: right;
                }
                .carousel-indicators {
                  bottom: 0;
                  left: 50%;
                  transform: translateX(-50%);
                }
              }
            }
          }
          &.pc {
            height: 400px;
            padding-bottom: 30px;
            box-sizing: content-box;
          }
          &.mob {
            width: 100%;
            height: auto;
            padding-bottom: 0;
            .shouhuoz {
              img {
                width: 100%;
              }
              img:nth-of-type(2) {
                margin-top: -35px;
              }
              .wenzi {
                width: 100%;
                margin-top: 0;
                .slogan {
                  width: 100%;
                  padding: 0 15px;
                  p {
                    font-size: 14px;
                  }
                  h6 {
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
      &.ruguo {
        padding: 0;
        .con {
          h1 {
            padding-top: 75px;
            padding-bottom: 60px;
          }
          .row {
            .kb2 {
              width: 1px;
              height: 156px;
              float: left;
              background: #d9dce2;
              margin-top: 58px;
            }
            .col-lg-4 {
              width: 33%;
              padding-left: 10px;
              padding-right: 10px;
              .img {
                width: 82%;
                margin: 0 auto;
                img {
                  width: 80%;
                  margin: 0 auto;
                }
                p {
                  font-size: 16.67px;
                  line-height: 25px;
                  color: #01255e;
                  margin-top: 30px;
                  text-align: left;
                }
              }
            }
          }
          h2 {
            font-size: 30px;
            color: #01255e;
            text-align: center;
            padding-top: 70px;
            margin-bottom: 70px;
            letter-spacing: 8px;
          }
          &.mob {
            .row {
              .col-sm-12 {
                .img {
                  width: 80%;
                  margin: 0 auto;
                  img {
                    width: 75%;
                  }
                  p {
                    margin-top: 12px;
                    padding-bottom: 35px;
                    color: #01255e;
                    font-size: 16px;
                    line-height: 20px;
                    text-align: left;
                  }
                }
              }
            }
            h2 {
              font-size: 26px;
              color: #01255e;
              padding-top: 0;
              margin-bottom: 35px;
              letter-spacing: 5px;
            }
          }
        }
      }
      &.huigu {
        background-repeat: no-repeat;
        background-position: center top;
        background: url('../assets/img/huigu_bg.png') no-repeat 50%;
        background-size: auto 100%;
        &::before {
          display: none;
        }
        .con {
          height: auto;
          min-height: 380px;
          max-width: 1300px;
          background: transparent;
          h1 {
            padding-top: 65px;
            padding-bottom: 20px;
          }
        }
        @media (min-width: 1920px) {
          background-size: 100% auto;
        }
        @media (max-width: 767px) {
          .con {
            min-height: 280px;
          }
        }
      }
      &.history_com {
        margin-bottom: 60px;
        .con {
          h1 {
            padding-top: 70px;
            padding-bottom: 40px;
          }
          ul {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            // margin-left: 10px;
            justify-content: center;
            li {
              //  float: left;
              width: 20%;
              padding-left: 1.75%;
              padding-right: 1.75%;
              text-align: center;
              // margin-bottom: 38px;
              // &.long {
              //   min-width: 200px;
              //   margin-bottom: 0;
              // }
              min-width: 200px;
              margin-top: 38px;
              &:nth-of-type(1),
              &:nth-of-type(2) {
                margin-top: 0;
              }
              div {
                background: #ffffff;
                width: 100%;
                height: 84px;
                overflow: hidden;
                border: 1px solid #e6e6e6;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                * {
                  width: auto;
                  height: auto;
                  // max-width: 100%;
                  max-width: 96%;
                  max-height: 80px;
                }
              }
            }
          }
        }
      }
      @media (min-width: 1000px) {
        &.history_com .con ul li {
          &:nth-of-type(3),
          &:nth-of-type(4),
          &:nth-of-type(5) {
            margin-top: 0;
          }
        }
      }
      @media (min-width: 800px) {
        &.history_com .con ul li {
          &:nth-of-type(3),
          &:nth-of-type(4) {
            margin-top: 0;
          }
        }
      }
      @media (min-width: 630px) {
        &.history_com .con ul li {
          &:nth-of-type(3) {
            margin-top: 0;
          }
        }
      }
      @media (max-width: 767px) {
        &.anli .con .h1 {
          .refresh {
            width: 20px;
            height: 20px;
            margin-left: 65px;
          }
        }
        &.jieshao .con {
          h1.h1 {
            font-size: 17px;
            line-height: 1.2;
            padding-top: 20px;
            padding-bottom: 12px;
            letter-spacing: 0;
          }
          p {
            font-size: 13px;
            line-height: 20px;
            margin-top: 0;
            margin-bottom: 0;
            padding-bottom: 20px;
          }
        }
        &.ruguo .con .row .col-lg-4 {
          float: left;
          padding-left: 0;
          padding-right: 0;
        }
      }
      @media (max-width: 600px) {
        &.history_com {
          margin-bottom: 1px;
          .con {
            margin-bottom: 20px;
            ul {
              // display: block;
              display: inline-block;
              li {
                width: 50%;
                min-width: 0 !important;
                float: left;
                // margin-bottom: 15px;
                margin-top: 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                div {
                  height: 60px;
                  // display: flex;
                  // justify-content: center;
                  // align-items: center;
                  * {
                    max-height: 60px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Home.vue